// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3-3R6","ranges":"BmiRanges_ranges__3q2gN"};